<template>
  <div class="GameSet">
    <div class="top">
      <div class="t_l">
        <a-button v-permission="`Content.LevelSeting.Cache`" @click="clearCache" type="primary" icon="info-circle">清空缓存 </a-button>
        <a-button v-permission="`Content.LevelSeting.Export`" @click="logoutXLSX" type="primary" icon="logout"> 导出关卡 </a-button>
        <a-button v-permission="`Content.LevelSeting.Import`" type="primary" icon="import" @click="importRelevant.visible = true">导入关卡 </a-button>
        <a-button v-permission="`Content.LevelSeting.DeleteAll`" icon="delete" @click="deleteAll" type="danger"> 批量删除 </a-button>
        <a-badge :dot="dotShow" class="badge-dot" v-permission="`Content.LevelSeting.updateRecord`">
          <a-button style="margin-right: 0" v-permission="`Content.LevelSeting.updateRecord`" icon="edit" @click="updateRecord" type="primary"> 修改记录 </a-button>
        </a-badge>
      </div>
    </div>
    <div class="bottom">
      <a-table
        :columns="columns"
        :row-selection="rowSelection"
        :data-source="tableRelevant.tableDataSource"
        :loading="tableRelevant.tableLoading"
        :pagination="false"
        row-key="关卡标识"
        bordered
        size="middle"
        :scroll="{ y: 600, x: columns.length > 10 ? `calc(${(columns.length - 10) * 100}px + 100%)` : '100%' }"
      >
        <div slot="action" slot-scope="text, record" v-permission="`Content.LevelSeting.Delete`">
          <a-popconfirm title="确定删除？" @confirm="deleteLevel(record)">
            <a style="color: #f00">
              <a-icon type="delete" />
              删除
            </a>
          </a-popconfirm>
        </div>
      </a-table>
    </div>

    <a-modal width="600px" title="批量导入关卡" :centered="true" v-model="importRelevant.visible" :footer="null">
      <a-spin :spinning="importRelevant.confirmLoading">
        <a-divider orientation="left">关卡模板下载</a-divider>
        <p style="text-align: center">
          <a download="关卡模板下载" :href="DownloadTemplate | filterUrl">点击下载模板</a>
        </p>
        <a-divider orientation="left">批量导入关卡</a-divider>
        <a-upload-dragger name="file" :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload">
          <p class="ant-upload-drag-icon">
            <a-icon type="cloud-upload" />
          </p>
          <p class="ant-upload-text" style="color: #666">点击上传文件，或将文件拖拽到此处</p>
          <p class="ant-upload-hint">（支持扩展名为xlsx文件）</p>
        </a-upload-dragger>
        <p style="text-align: center; margin: 20px 0">
          <a-button @click="importlevel" type="primary">导入数据</a-button>
        </p>
      </a-spin>
    </a-modal>
    <updateRecordModal ref="updateRecordRef" :gameId="gameId" :columns="columns" @newNotice="(e) => (dotShow = e)" />
  </div>
</template>

<script>
import XLSX from 'xlsx'
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import updateRecordModal from './updateRecordModal.vue'

// 根据表头类型获取颜色
const getHeaderColor = (type) => {
  const colorMap = {
    1: '#52c41a', // 主参数 - 绿色
    2: '#1890ff', // 副参数 - 蓝色
    3: '#000'     // 其他参数 - 黑色
  }
  return colorMap[type] || '#000'
}

export default {
  name: 'GameSet',
  components: { updateRecordModal },
  data() {
    return {
      visible: false,
      dotShow: false,
      DownloadTemplate: process.env.VUE_APP_TEMPLATE_URL + '/template/excel/关卡配置模板.xlsx',
      columns: [],
      //表格相关
      tableRelevant: tableRelevant.call(this),
      gameId: this.$route.query.id,
      baseURL: process.env.VUE_APP_API_BASE_URL,
      errorFile: false,
      errorUrl: '',
      fileList: [],
      importRelevant: {
        visible: false,
        confirmLoading: false,
      },
      file: '',
      levelHeadr: [],
      levelValue: [],
      ismodal: false,
      levelPagelistData: [], // 存储 levelPagelist 返回的数据
      addForm: {
        levelSign: '',
        levelName: '',
        value: [],
      },
      excel: {
        json_fields: {},
      },
      selectedRowKeys: [],
    }
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys:this.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
        },
      }
    },
  },
  created() {
    this.initTableColumns()
    this.levelDataList()
  },
  methods: {
    updateRecord() {
      this.$refs['updateRecordRef'].showModal()
    },
    clearCache() {
      this.$confirm({
        title: `确认清空【${this.$route.query.name}】关卡缓存？`,
        centered: true,
        onOk: () => {
          const form = new FormData()
          form.append('tainGameId', this.gameId)
          this.$http.clearGameCache(form).then((res) => {
            const { message } = res.data
            this.$message.success(message)
          })
        },
      })
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    logoutXLSX() {
      // 准备三行表头：参数类型、中文说明、字段名
      const typeMap = {}
      const descMap = {}

      // 从 levelPagelistData 中获取 type 和 chineseDesc 映射
      // 注意：levelPagelist 返回的数据已统一使用 chineseDesc 字段
      this.levelPagelistData.forEach((v) => {
        // 统一使用小写的 header 键名
        const headerKey = v.header === 'PreparationTime' ? 'preparationTime' : v.header

        typeMap[headerKey] = v.type
        descMap[headerKey] = v.chineseDesc || v.ChineseDesc || ''
      })

      // 构建 Excel 导出数据，过滤掉操作列
      const excelFields = {}
      for (const title in this.excel.json_fields) {
        if (title !== '操作') {
          excelFields[title] = this.excel.json_fields[title]
        }
      }

      // 获取动态列的字段名列表
      // 注意：dataIndex 可能是 v.header 的值（已处理为小写）
      const dynamicKeys = Object.values(excelFields).filter(
        (key) => key !== '关卡标识' && key !== '关卡名称'
      )

      const arr = []

      // 第一行：参数类型（一二列合并显示"参数类型"）
      const typeRow = ['参数类型', '', ...dynamicKeys.map(key => {
        const type = typeMap[key] || 3
        const typeMapCN = { 1: '主参数', 2: '副参数', 3: '其他参数' }
        return typeMapCN[type] || '其他参数'
      })]
      arr.push(typeRow)

      // 第二行：中文说明（一二列合并显示"中文说明"）
      const descRow = ['中文说明', '', ...dynamicKeys.map(key => descMap[key] || '')]
      arr.push(descRow)

      // 第三行：字段名
      const headerRow = ['关卡标识', '关卡名称', ...dynamicKeys]
      arr.push(headerRow)

      // 数据行
      this.tableRelevant.tableDataSource.forEach((v) => {
        let itemArr = []
        for (const title in excelFields) {
          itemArr.push(v[excelFields[title]])
        }
        arr.push(itemArr)
      })

      // 创建工作表
      const aoa = XLSX.utils.aoa_to_sheet(arr)

      // 添加合并单元格配置
      // 第一行：合并第1、2列（显示"参数类型"）
      // 第二行：合并第1、2列（显示"中文说明"）
      const mergeConfig = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 1 } }, // 第一行合并第1、2列（参数类型）
        { s: { r: 1, c: 0 }, e: { r: 1, c: 1 } }  // 第二行合并第1、2列（中文说明）
      ]

      if (!aoa['!merges']) {
        aoa['!merges'] = []
      }
      aoa['!merges'].push(...mergeConfig)

      const book = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(book, aoa, '第一页')
      XLSX.writeFile(book, '关卡数据.xlsx')
    },
    initTableColumns() {
      this.excel.json_fields = {} // 清空字段映射，避免累积历史数据
      return this.$http.levelPagelist({ tainGameId: this.gameId }).then((res) => {
        const { data } = res.data
        // data 是数组，每个元素有 type, chineseDesc, header 字段
        // type: 1=主参数(绿色), 2=副参数(蓝色), 3=其他参数(黑色)
        // chineseDesc: 中文说明
        // header: 对应的数据字段名
        // 保存原始数据供导出使用
        // 注意：需要先处理 PreparationTime 的映射，然后再保存
        const processedData = JSON.parse(JSON.stringify(data))
        this.levelPagelistData = processedData

        data.forEach((v) => {
          if (v.header === 'PreparationTime') {
            v.header = 'preparationTime'
          }
        })

        // 同时处理描述字段，统一使用 chineseDesc
        processedData.forEach((v) => {
          if (v.ChineseDesc && !v.chineseDesc) {
            v.chineseDesc = v.ChineseDesc
          }
          if (v.header === 'PreparationTime') {
            v.header = 'preparationTime'
          }
        })
        const arr = [
          { title: '关卡标识', dataIndex: '关卡标识', align: 'center' },
          { title: '关卡名称', dataIndex: '关卡名称', align: 'center' },
          ...data.map((v) => ({
            title: `${v.chineseDesc} (${v.header})`,
            dataIndex: v.header,
            align: 'center',
            customHeaderCell: () => ({
              style: {
                color: getHeaderColor(v.type),
                fontWeight: 'bold'
              }
            })
          })),
          {
            title: '操作',
            scopedSlots: { customRender: 'action' },
            fixed: 'right',
            width: 150,
            align: 'center',
          },
          ]
          this.columns = arr
          //导出excel的数据
          arr.forEach((v) => {
            if (v['title'] !== '操作') this.excel.json_fields[v['title']] = v.dataIndex
          })
      })
    },
    levelDataList() {
      let params = {
        tainGameId: this.gameId,
      }
      this.tableRelevant.tableLoading = true
      this.$http.levelDataList(params).then((res) => {
        this.tableRelevant.tableLoading = false
        const { data } = res.data
        this.tableRelevant.tableDataSource = data
        this.$refs['updateRecordRef'].getRecordList(false, true)
      })
    },
    beforeUpload(file) {
      if (file.name.substr(-4, 4) !== 'xlsx') {
        this.$message.error('请选择以“.xlsx”结尾的文件')
        return false
      }
      this.fileList = [file]
      return false
    },
    importlevel() {
      this.$message.destroy()
      if (!this.fileList.length) {
        this.$message.error('请选择文件')
        return
      }
      let formData = new FormData()
      formData.append('excelfile', this.fileList[0])
      formData.append('trainGameId', this.gameId)
      this.importRelevant.confirmLoading = true
      this.$http.inportlevelData(formData).then((res) => {
        this.importRelevant.confirmLoading = false
        // 先重新获取列定义，再获取关卡数据，确保数据一致性
        this.initTableColumns().then(() => {
          this.levelDataList()
        })
        this.file = ''
        this.fileList = []
        this.importRelevant.visible = false
      }).catch(() => {
        this.importRelevant.confirmLoading = false
        // 请求异常时清空文件列表
        this.fileList = []
      })
    },
    addLevel() {
      var models = []
      this.addForm.value.forEach((item, index) => {
        this.levelHeadr.forEach((el, i) => {
          if (index == i) {
            models.push({
              LevelSign: this.addForm.levelSign,
              LevelName: this.addForm.levelName,
              HeaderId: el.id,
              HeaderValue: item,
              TrainGameId: el.trainGameId,
            })
          }
        })
      })
      let formData = new FormData()
      models.forEach((item, index) => {
        for (let key in item) {
          formData.append(`models[${index}][${key}]`, item[key])
        }
      })
      this.$http.addlevelData(formData).then((res) => {
          this.levelPagelist()
          this.levelDataList()
          this.$message.destroy()
          this.$message.success('添加成功')
          this.ismodal = false

      })
    },
    deleteLevel(record) {
      this.$message.destroy()
      const params = {
        tainGameId: this.gameId,
        levels: [record.关卡标识],
      }
      this.tableRelevant.tableLoading = true
      this.$http.deletelevelData(params).then((res) => {
        this.tableRelevant.tableLoading = false
          this.levelDataList()
          this.selectedRowKeys = []
          this.$message.success('删除成功')

      })
    },
    deleteAll() {
      if (!this.selectedRowKeys.length) {
        this.$message.destroy()
        this.$message.error('请选择关卡')
        return
      }
      const that = this
      this.$confirm({
        title: `确认删除选中的 ${that.selectedRowKeys.length} 个关卡？`,
        okType: 'danger',
        centered: true,
        onOk() {
          const params = {
            tainGameId: that.gameId,
            levels: that.selectedRowKeys,
          }
          that.tableRelevant.tableLoading = true
          that.$http.deletelevelData(params).then((res) => {
            that.tableRelevant.tableLoading = false
            const { status, message } = res.data

              that.$message.success(message)
              that.levelDataList()
              that.selectedRowKeys = []

          })
        },
      })
    },
  },
}
</script>

<style scoped>
/deep/ .searchForm {
  display: flex;
}

/deep/ .searchForm .fold {
  width: 91%;
  display: flex;
}
</style>
<style scoped lang="less">
.top {
  display: flex;
  justify-content: space-between;
  .t_l {
    width: 100%;
    line-height: 2;
    button {
      margin-right: 20px;
    }
  }
}

.bottom {
  margin-top: 15px;
}

.subBox {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.importBox {
  margin-top: 15px;
}

.editBtn {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.badge-dot ::v-deep .ant-badge-dot {
  width: 8px !important;
  height: 8px !important;
}
</style>
